<template>
  <div>

    <!-- cards -->
    <div class="container">
      <h2 v-if="wheelstates==''">{{cardcard}} {{$cards.find( ({ name }) => name == this.cardcard ).plural ? 'Are' : 'is'}} Not Grown in {{statestate}}</h2>
      <h2 v-else>Months {{cardcard}} {{$cards.find( ({ name }) => name == this.cardcard ).plural ? 'Are' : 'is'}} in Season in {{statestate}}</h2>
      <div class="row">
        <div v-for="(card,index) in [$cards.find( ({ name }) => name == cardcard )]" :key="index" class="col xl2 vegCard">
            <div class="card">

                <div class="col m5 s5 xs12 card_col" style="padding:0">
                  <img :src="getImgUrl(card.image)" v-bind:alt="card.image" class="card-image1">
                  <div class="cardTop">
                    <h3 class="card_title" style="margin-bottom:3px">{{card.name}}</h3>
                    <p class="card-type" style="pagging-left:0">{{card.type}}</p>
                  </div>
                  
                  <p class="card-content">{{card.desc}}</p>
                  <div class="card_action" style="padding-bottom:5px">
                    <a class="btn-outline-primary" :href="'https://foodprint.org/real-food/'+toURL(card.cat_id)" target="_blank">Learn & Cook</a>
                  </div>
                </div>
                <div class="col m7 s7 xs12"  style="padding:0">

                  <div class="cardTop">
                  <h3 v-if="wheelstates!=''" class="card_title" style="margin-bottom:3px">{{statestate}}</h3>
                  <p class="card-content" style="padding-left:0">{{vlookup (card,statestate)}}</p>
                  </div>

                    <div class="wheel-container">
                      <div class="svg-container" :class="{ mtop: wheelstates=='' }">
                        <svg style="z-index: 2;" data-name="wheel-gray" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
                          <path class="wheel-month-gray" d="M64.17,77.86a31.85,31.85,0,0,1-14.29,3.65V88a38.36,38.36,0,0,0,17.58-4.52Z" />
                          <path class="wheel-month-gray" d="M21.09,64.65a31.83,31.83,0,0,1-3.76-13.47H10.79a38.34,38.34,0,0,0,4.59,16.66Z" />
                          <path class="wheel-month-gray" d="M47.87,88V81.49a31.84,31.84,0,0,1-14-3.92l-3.27,5.65A38.33,38.33,0,0,0,47.87,88Z" />
                          <path class="wheel-month-gray" d="M33.87,21.45A31.84,31.84,0,0,1,48,17.52V11A38.33,38.33,0,0,0,30.6,15.8Z" />
                          <path class="wheel-month-gray" d="M10.76,49.18h6.53a31.86,31.86,0,0,1,3.56-14.35l-5.64-3.32A38.36,38.36,0,0,0,10.76,49.18Z" />
                          <path class="wheel-month-gray" d="M50,11V17.5a31.85,31.85,0,0,1,14.2,3.66l3.27-5.66A38.36,38.36,0,0,0,50,11Z" />
                          <path class="wheel-month-gray" d="M32.18,76.56A32.18,32.18,0,0,1,21.94,66.13l-5.68,3.23A38.74,38.74,0,0,0,28.91,82.22Z" />
                          <path class="wheel-month-gray" d="M87.81,51.18H81.28a31.82,31.82,0,0,1-4.08,14l5.67,3.24A38.32,38.32,0,0,0,87.81,51.18Z" />
                          <path class="wheel-month-gray" d="M76.38,66.59A32.18,32.18,0,0,1,65.92,76.88l3.27,5.66A38.74,38.74,0,0,0,82,69.87Z" />
                          <path class="wheel-month-gray" d="M22,32.74A32.18,32.18,0,0,1,32.15,22.48l-3.27-5.66A38.74,38.74,0,0,0,16.37,29.46Z" />
                          <path class="wheel-month-gray" d="M77.73,34.77a31.86,31.86,0,0,1,3.59,14.4h6.53A38.36,38.36,0,0,0,83.4,31.51Z" />
                          <path class="wheel-month-gray" d="M66,22.15A32.18,32.18,0,0,1,76.61,32.79l5.69-3.22A38.75,38.75,0,0,0,69.22,16.49Z" />
                        </svg>
                      </div>
                      <div class="svg-container" :class="{ mtop: wheelstates=='' }">
                        <svg style="z-index: 1" data-name="wheel-green" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
                          <path :class="[wheelstates.indexOf('Early April')>-1 ? 'wheel-month-green' : 'nonedisp']" d="M94.45,61.48A46.25,46.25,0,0,0,96,51.17H81.47a31.8,31.8,0,0,1-1,6.55Z" />
                          <path :class="[wheelstates.indexOf('Late April')>-1 ? 'wheel-month-green' : 'nonedisp']" d="M80.36,58a31.81,31.81,0,0,1-3,7.21L90,72.38a46.26,46.26,0,0,0,4.39-10.66Z" />
                          <path :class="[wheelstates.indexOf('Early January')>-1 ? 'wheel-month-green' : 'nonedisp']" d="M61.24,4.47A46.32,46.32,0,0,0,50.19,3v14.5a31.85,31.85,0,0,1,7.3,1Z" />
                          <path :class="[wheelstates.indexOf('Late January')>-1 ? 'wheel-month-green' : 'nonedisp']" d="M61.49,4.54l-3.76,14a31.84,31.84,0,0,1,6.66,2.59L71.66,8.56A46.31,46.31,0,0,0,61.49,4.54Z" />
                          <path :class="[wheelstates.indexOf('Early July')>-1 ? 'wheel-month-green' : 'nonedisp']" d="M37.4,94.42A46.27,46.27,0,0,0,48,96V81.47a31.83,31.83,0,0,1-6.89-1.07Z" />
                          <path :class="[wheelstates.indexOf('Late July')>-1 ? 'wheel-month-green' : 'nonedisp']" d="M40.91,80.34A31.83,31.83,0,0,1,34,77.55L26.81,90.13a46.27,46.27,0,0,0,10.35,4.23Z" />
                          <path :class="[wheelstates.indexOf('Late February')>-1 ? 'wheel-month-green' : 'nonedisp']" d="M82.41,16.58,72.14,26.85a32.18,32.18,0,0,1,4.66,5.93l12.65-7.16A46.77,46.77,0,0,0,82.41,16.58Z" />
                          <path :class="[wheelstates.indexOf('Early February')>-1 ? 'wheel-month-green' : 'nonedisp']" d="M82.23,16.41a46.76,46.76,0,0,0-8.78-6.85L66.19,22.14A32.18,32.18,0,0,1,72,26.68Z" />
                          <path :class="[wheelstates.indexOf('Early August')>-1 ? 'wheel-month-green' : 'nonedisp']" d="M16.59,82.4a46.76,46.76,0,0,0,8.5,6.73l7.28-12.58a32.17,32.17,0,0,1-5.51-4.42Z" />
                          <path :class="[wheelstates.indexOf('Late August')>-1 ? 'wheel-month-green' : 'nonedisp']" d="M16.41,82.22,26.68,72a32.17,32.17,0,0,1-4.55-5.84L9.51,73.32A46.77,46.77,0,0,0,16.41,82.22Z" />
                          <path :class="[wheelstates.indexOf('Early March')>-1 ? 'wheel-month-green' : 'nonedisp']" d="M94.4,37.3a46.3,46.3,0,0,0-3.88-9.8l-12.6,7.26a31.84,31.84,0,0,1,2.45,6.3Z" />
                          <path :class="[wheelstates.indexOf('Late March')>-1 ? 'wheel-month-green' : 'nonedisp']" d="M94.47,37.54l-14,3.76a31.85,31.85,0,0,1,1.07,7.86H96A46.3,46.3,0,0,0,94.47,37.54Z" />
                          <path :class="[wheelstates.indexOf('Late September')>-1 ? 'wheel-month-green' : 'nonedisp']" d="M18.53,57.63a31.82,31.82,0,0,1-1-6.46H3A46.28,46.28,0,0,0,4.5,61.39Z" />
                          <path :class="[wheelstates.indexOf('Early September')>-1 ? 'wheel-month-green' : 'nonedisp']" d="M4.55,61.63a46.28,46.28,0,0,0,4,10.1l12.69-7.09a31.82,31.82,0,0,1-2.69-6.77Z" />
                          <path :class="[wheelstates.indexOf('Late October')>-1 ? 'wheel-month-green' : 'nonedisp']" d="M18.59,41.15A31.85,31.85,0,0,1,21,34.82L8.5,27.44a46.31,46.31,0,0,0-3.94,10Z" />
                          <path :class="[wheelstates.indexOf('Early October')>-1 ? 'wheel-month-green' : 'nonedisp']" d="M4.49,37.63A46.31,46.31,0,0,0,3,49.17H17.48a31.85,31.85,0,0,1,1-7.78Z" />
                          <path :class="[wheelstates.indexOf('Early May')>-1 ? 'wheel-month-green' : 'nonedisp']" d="M82.38,82.41a46.76,46.76,0,0,0,6.76-8.53l-12.57-7.3a32.17,32.17,0,0,1-4.46,5.56Z" />
                          <path :class="[wheelstates.indexOf('Late May')>-1 ? 'wheel-month-green' : 'nonedisp']" d="M71.94,72.32a32.18,32.18,0,0,1-5.83,4.55l7.27,12.57a46.77,46.77,0,0,0,8.83-6.85Z" />
                          <path :class="[wheelstates.indexOf('Late November')>-1 ? 'wheel-month-green' : 'nonedisp']" d="M26.84,26.87a32.17,32.17,0,0,1,5.5-4.4L25.06,9.88a46.77,46.77,0,0,0-8.48,6.72Z" />
                          <path :class="[wheelstates.indexOf('Early November')>-1 ? 'wheel-month-green' : 'nonedisp']" d="M16.4,16.78a46.78,46.78,0,0,0-6.76,8.66l12.55,7.29A32.18,32.18,0,0,1,26.66,27Z" />
                          <path :class="[wheelstates.indexOf('Late December')>-1 ? 'wheel-month-green' : 'nonedisp']" d="M41.15,18.59a31.83,31.83,0,0,1,7-1.08V3a46.28,46.28,0,0,0-10.8,1.58Z" />
                          <path :class="[wheelstates.indexOf('Early December')>-1 ? 'wheel-month-green' : 'nonedisp']" d="M37.15,4.62A46.29,46.29,0,0,0,26.79,8.87l7.27,12.57a31.84,31.84,0,0,1,6.85-2.79Z" />
                          <path :class="[wheelstates.indexOf('Early June')>-1 ? 'wheel-month-green' : 'nonedisp']" d="M57.48,80.5a31.85,31.85,0,0,1-7.41,1V96a46.32,46.32,0,0,0,11.17-1.49Z" />
                          <path :class="[wheelstates.indexOf('Late June')>-1 ? 'wheel-month-green' : 'nonedisp']" d="M61.48,94.47a46.31,46.31,0,0,0,10.18-4l-7.3-12.59a31.84,31.84,0,0,1-6.64,2.58Z" />
                        
                        </svg>
                      </div>
                      <div class="svg-container" :class="{ mtop: wheelstates=='' }">
                        <svg id="wheel-white" data-name="wheel-months" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
                          <text :class="[curmth=='JAN' ? 'wheel-red-text' : 'wheel-white-text']" v-on:click="setmonth(months[0])" transform="matrix(0.99, 0.12, -0.12, 0.99, 51.53, 16.74)">J</text>
                          <text :class="[curmth=='JAN' ? 'wheel-red-text' : 'wheel-white-text']" v-on:click="setmonth(months[0])" transform="matrix(0.97, 0.23, -0.23, 0.97, 54.57, 17.05)">A</text>
                          <text :class="[curmth=='JAN' ? 'wheel-red-text' : 'wheel-white-text']" v-on:click="setmonth(months[0])" transform="translate(58.78 18) rotate(20.97)">N</text>
                          <text :class="[curmth=='FEB' ? 'wheel-red-text' : 'wheel-white-text']" v-on:click="setmonth(months[2])" transform="translate(68.07 22.55) rotate(37.92)">F</text>
                          <text :class="[curmth=='FEB' ? 'wheel-red-text' : 'wheel-white-text']" v-on:click="setmonth(months[2])" transform="translate(70.76 24.63) rotate(43.98)">E</text>
                          <text :class="[curmth=='FEB' ? 'wheel-red-text' : 'wheel-white-text']" v-on:click="setmonth(months[2])" transform="matrix(0.64, 0.77, -0.77, 0.64, 73.36, 27.11)">B</text>
                          <text :class="[curmth=='MAR' ? 'wheel-red-text' : 'wheel-white-text']" v-on:click="setmonth(months[4])" transform="translate(78.86 34.96) rotate(68.88)">M</text>
                          <text :class="[curmth=='MAR' ? 'wheel-red-text' : 'wheel-white-text']" v-on:click="setmonth(months[4])" transform="matrix(0.21, 0.98, -0.98, 0.21, 80.86, 40.28)">A</text>
                          <text :class="[curmth=='MAR' ? 'wheel-red-text' : 'wheel-white-text']" v-on:click="setmonth(months[4])" transform="translate(81.78 44.5) rotate(84.79)">R</text>
                          <text :class="[curmth=='APR' ? 'wheel-red-text' : 'wheel-white-text']" v-on:click="setmonth(months[6])" transform="translate(82.02 52.79) rotate(99.55)">A</text>
                          <text :class="[curmth=='APR' ? 'wheel-red-text' : 'wheel-white-text']" v-on:click="setmonth(months[6])" transform="translate(81.3 57.04) rotate(106.66)">P</text>
                          <text :class="[curmth=='APR' ? 'wheel-red-text' : 'wheel-white-text']" v-on:click="setmonth(months[6])" transform="translate(80.22 60.69) rotate(113.45)">R</text>
                          <text :class="[curmth=='MAY' ? 'wheel-red-text' : 'wheel-white-text']" v-on:click="setmonth(months[8])" transform="translate(76.3 68.36) rotate(130.01)">M</text>
                          <text :class="[curmth=='MAY' ? 'wheel-red-text' : 'wheel-white-text']" v-on:click="setmonth(months[8])" transform="translate(72.61 72.69) rotate(138.69)">A</text>
                          <text :class="[curmth=='MAY' ? 'wheel-red-text' : 'wheel-white-text']" v-on:click="setmonth(months[8])" transform="translate(69.67 75.31) rotate(145.22)">Y</text>
                          <text :class="[curmth=='JUN' ? 'wheel-red-text' : 'wheel-white-text']" v-on:click="setmonth(months[10])" transform="matrix(-0.92, 0.38, -0.38, -0.92, 63.37, 79.19)">J</text>
                          <text :class="[curmth=='JUN' ? 'wheel-red-text' : 'wheel-white-text']" v-on:click="setmonth(months[10])" transform="translate(60.51 80.43) rotate(164.05)">U</text>
                          <text :class="[curmth=='JUN' ? 'wheel-red-text' : 'wheel-white-text']" v-on:click="setmonth(months[10])" transform="matrix(-0.99, 0.14, -0.14, -0.99, 56.33, 81.64)">N</text>
                          <text :class="[curmth=='JUL' ? 'wheel-red-text' : 'wheel-white-text']" v-on:click="setmonth(months[12])" transform="translate(45.27 82.11) rotate(-170.18)">J</text>
                          <text :class="[curmth=='JUL' ? 'wheel-red-text' : 'wheel-white-text']" v-on:click="setmonth(months[12])" transform="translate(42.2 81.62) rotate(-163.61)">U</text>
                          <text :class="[curmth=='JUL' ? 'wheel-red-text' : 'wheel-white-text']" v-on:click="setmonth(months[12])" transform="translate(38 80.35) rotate(-157.03)">L</text>
                          <text :class="[curmth=='AUG' ? 'wheel-red-text' : 'wheel-white-text']" v-on:click="setmonth(months[14])" transform="matrix(-0.78, -0.62, 0.62, -0.78, 30.62, 76.56)">A</text>
                          <text :class="[curmth=='AUG' ? 'wheel-red-text' : 'wheel-white-text']" v-on:click="setmonth(months[14])" transform="matrix(-0.7, -0.72, 0.72, -0.7, 27.32, 73.95)">U</text>
                          <text :class="[curmth=='AUG' ? 'wheel-red-text' : 'wheel-white-text']" v-on:click="setmonth(months[14])" transform="matrix(-0.59, -0.8, 0.8, -0.59, 24.28, 70.84)">G</text>
                          <text :class="[curmth=='SEP' ? 'wheel-red-text' : 'wheel-white-text']" v-on:click="setmonth(months[16])" transform="matrix(-0.36, -0.93, 0.93, -0.36, 19.33, 62.97)">S</text>
                          <text :class="[curmth=='SEP' ? 'wheel-red-text' : 'wheel-white-text']" v-on:click="setmonth(months[16])" transform="matrix(-0.26, -0.97, 0.97, -0.26, 18.07, 59.73)">E</text>
                          <text :class="[curmth=='SEP' ? 'wheel-red-text' : 'wheel-white-text']" v-on:click="setmonth(months[16])" transform="translate(17.14 56.26) rotate(-98.38)">P</text>
                          <text :class="[curmth=='OCT' ? 'wheel-red-text' : 'wheel-white-text']" v-on:click="setmonth(months[18])" transform="translate(16.44 47.79) rotate(-82.56)">O</text>
                          <text :class="[curmth=='OCT' ? 'wheel-red-text' : 'wheel-white-text']" v-on:click="setmonth(months[18])" transform="matrix(0.27, -0.96, 0.96, 0.27, 17.12, 42.77)">C</text>
                          <text :class="[curmth=='OCT' ? 'wheel-red-text' : 'wheel-white-text']" v-on:click="setmonth(months[18])" transform="translate(18.22 38.85) rotate(-67.94)">T</text>
                          <text :class="[curmth=='NOV' ? 'wheel-red-text' : 'wheel-white-text']" v-on:click="setmonth(months[20])" transform="translate(21.7 31.63) rotate(-52.85)">N</text>
                          <text :class="[curmth=='NOV' ? 'wheel-red-text' : 'wheel-white-text']" v-on:click="setmonth(months[20])" transform="translate(24.51 27.87) rotate(-44.4)">O</text>
                          <text :class="[curmth=='NOV' ? 'wheel-red-text' : 'wheel-white-text']" v-on:click="setmonth(months[20])" transform="matrix(0.8, -0.6, 0.6, 0.8, 28.07, 24.42)">V</text>
                          <text :class="[curmth=='DEC' ? 'wheel-red-text' : 'wheel-white-text']" v-on:click="setmonth(months[22])" transform="translate(35.34 19.72) rotate(-20.99)">D</text>
                          <text :class="[curmth=='DEC' ? 'wheel-red-text' : 'wheel-white-text']" v-on:click="setmonth(months[22])" transform="translate(39.65 18.1) rotate(-13.8)">E</text>
                          <text :class="[curmth=='DEC' ? 'wheel-red-text' : 'wheel-white-text']" v-on:click="setmonth(months[22])" transform="translate(43.1 17.23) rotate(-7.12)">C</text>
                        </svg>
                      </div>
                    </div>
                  </div>
                </div>
        </div>
      </div>
    </div>
</div>
</template>


<script>

import { listStates } from "@/components/staticFiles/stateLookup.js"
import { listmonths } from '@/components/staticFiles/months.js'
import { getdate } from '@/components/api/getdate.js'
import { getImgUrl, toURL, toURLreverse } from '@/components/api/imagepath.js'

export default {

    // passing props from app.vue
    props: ['card','state'],

    // funcs that catitalizes the 1st letter of prop values
    computed: {
      statestate() {
        return toURLreverse(this.state)
      },

      cardcard() {
        return toURLreverse(this.card)
      }
    },

    data() {
      return {
        curmth:true,
        states1:listStates,
        months:listmonths,
        month:'Any Month',
        msg:'',
        wheelstates:'',

        // imported functions
        getdate:getdate,
        getImgUrl:getImgUrl,
        toURL:toURL,
        toURLreverse:toURLreverse
      }
    },

    methods: {

        // change selected month when clicking on a wheel
        setmonth(val) {
          return this.month=val
        },

        vlookup (card,state) {
          // getting 3 letters of current /or selected month
          this.curmth = (this.month.desc == "Any Month" || this.month.desc == "" || this.month.desc == null) ? (listmonths.find( ({ value }) => value == ((new Date()).getMonth()+1)*2 )).desc.split(' ')[1].slice(0,3).toUpperCase() : this.month.desc.split(' ')[1].slice(0,3).toUpperCase()
          let stateval = (listStates.find( ({ desc }) => desc == state )).value
          if (card.states[stateval]) {
            var arr1 = card.states[stateval].seasons
            var arr2 = []
            var arr3 = []
            for (let i in arr1) {
              // half-months for the wheel
              arr3[i] = (listmonths.find( ({ value }) => value == arr1[i] )).desc
              // full months to display
              arr2[i] = ' '+(listmonths.find( ({ value }) => value == arr1[i] )).desc.split(' ')[1]
            }
            this.wheelstates = Array.from(new Set(arr3)).toString()
            return Array.from(new Set(arr2)).toString()
          } else {
            this.wheelstates = ''
          }
        }
    }
}

</script>

<style scoped>

.container {
    /* margin-top:330px; */
    width: 80%;
}
h2 {
  font-size: 26px;
}
.card-content {
  flex-grow: 1;
}

/* vegcard */
.btn-outline-primary {
  padding: 7px 14px 7px 14px;
  width: 100%;
  margin-bottom: 0;
  text-transform: none;
}
.mtop {
  margin-top:10%
}
.card {
  height: auto;
  /* height: auto; */
  width:456px;
  display: flex;
  flex-direction: row;
  text-align: center;
  justify-content: center;
  min-height: 350px;

}
h3.card_title {
  margin:10px auto 10px auto
}
.card_col {
  width: 190px !important;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.178);
  transition: height 0.3s, box-shadow 0.3s;
  overflow: hidden;
  display: flex;
  flex-flow: column;
}
@media (max-width: 530px) {
  .card {
    flex-direction: column;
    height:auto;
    width:100%;
    justify-content: flex-start;
    padding-bottom: 70%;
  }
  .card_col {
    height: auto;
    width: 100% !important;
  }
  h3.card_title {
    /* margin:10px auto 20px 0 */
  }
  .cardTop {
    padding-left: 10px
  }
  .svg-container {
    height: 50%;
    width: 50%;
  }
  .container {
    margin-top:0
  }
  .btn-outline-primary {
    font-size: 20px;
  }
  .row .col.s7 {
    width: 100% !important;
  }
}
  @media (max-width: 460px) {
    .svg-container {
      height: 70%;
      width: 70%;
    }
      .card {
    padding-bottom: 90%;
  }
  }


.card_det {
      font-family: 'Droid Sans';
  width:390px;
}
p.card-content {
  padding:0px 10px 0px 10px;
  margin:0;
}

.card .card_action {
  border-top: 0;

}
.card_action{
  margin-top: 20px;
  margin-bottom: 18%;
}
a .card_title {
  color: #2c2c2c;
}
a:hover{
  text-decoration: none;
}
.card-image1{
  width:100%;
}


/* end vegcard */

/* header styles */


@media (max-width:600px) {


  .topMenuRow {
    height: 100%;
    /* margin-left: 200px;
    padding-right: 200px; */
  }

}
@media (max-width: 520px) {
  .mtop {
    margin-top:15%
  }
}
@media (max-width: 390px) {
  .mtop {
    margin-top:25%
  }
}
/* end header styles */
  

</style>